import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CurrenciesRoutingModule } from './currencies-routing.module';
import { CurrenciesComponent } from './currencies.component';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '@app/shared/shared.module';
import { ReferralClickIdModule } from '@app/unauthenticated/referral-click-id.module';

@NgModule({
  declarations: [CurrenciesComponent],
  imports: [CommonModule, CurrenciesRoutingModule, TranslateModule, SharedModule, ReferralClickIdModule],
})
export class CurrenciesModule {}
